import React from 'react';
import { Instagram, Phone } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import SEO from '../components/SEO';

 
const graduates = [
  {
    id: 2,
    name: 'Ash',
    businessName: 'Pretty Paws Dog Grooming',
    image: 'ash.jpeg',
    logo: 'https://customer-assets.emergentagent.com/job_8e5aba18-0f4c-4ba8-8a4e-aabd33fafd89/artifacts/bjnlldkw_4d9078be-d673-4f29-bf01-fd93680ab8e3.jpeg',
    instagram: 'prettypawsdoggrooming_x',
    phone: null,
  },
  {
    id: 3,
    name: 'Kelly',
    businessName: 'Pawsome Poochiez by Kelly',
    image: 'kelly.jpeg',
    logo: 'https://customer-assets.emergentagent.com/job_8e5aba18-0f4c-4ba8-8a4e-aabd33fafd89/artifacts/lyajf1bx_3de07bc2-261c-431d-85ee-d031cd3c686c.jpeg',
    instagram: 'pawsome.poochiez.by.kelly',
    phone: null,
  },
  {
    id: 4,
    name: 'Georgia',
    businessName: 'Martha, Betty & Co',
    image: 'georgia.jpeg',
    logo: 'https://customer-assets.emergentagent.com/job_8e5aba18-0f4c-4ba8-8a4e-aabd33fafd89/artifacts/znykp2il_de9312e1-a528-455a-b850-bee07b417554.jpeg',
    instagram: null,
    phone: '07835932158',
  },
  {
    id: 5,
    name: 'Rachael',
    businessName: 'Pawsome Pets Dog Grooming & Cattery',
    image: 'rachael.jpeg',
    logo: 'https://customer-assets.emergentagent.com/job_8e5aba18-0f4c-4ba8-8a4e-aabd33fafd89/artifacts/wcqzqvgx_e916e8e9-07f1-4af2-a928-9731028e0174.jpeg',
    instagram: 'pawsome_pets_doggrooming',
    phone: null,
  },
  {
    id: 6,
    name: 'Emma',
    businessName: "Em's V.I. Paws",
    image: 'emma.jpeg',
    logo: 'https://customer-assets.emergentagent.com/job_8e5aba18-0f4c-4ba8-8a4e-aabd33fafd89/artifacts/pxtsy1tj_d71f565f-3ddc-475e-8ce6-37a4a91254f5.jpeg',
    instagram: 'ems_vipaws',
    phone: null,
  },
];

const GraduatesPage = () => {
  return (
    <div className="min-h-screen bg-cream-50">
      <SEO 
        title="Our Team - Independent Dog Groomers Manchester"
        description="Meet our fantastic team of independent dog groomers at Pups & Dreams Spa in Manchester. Each groomer runs their own business and takes bookings independently in Denton, Greater Manchester."
        keywords="dog groomers Manchester, independent dog groomers Manchester, pet groomers team Manchester, dog grooming specialists Manchester, dog groomers Denton, Manchester dog grooming team"
      />
        <div className="relative">
                <img
                  src="https://customer-assets-jai6qajn.emergentagent.net/job_cb908532-31e5-45af-8861-2b55da6db76e/artifacts/049d91bfc1a90cec_213ef587-3625-4e3e-9b79-40a3912546b5.jpeg"
                  alt="Pups & Dreams Team"
                  className="rounded-3xl shadow-2xl w-full object-contain" />
                     </div>
      {/* Hero Section */}
      <section className="bg-white !pt-[80px] !pb-[40px]">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-block bg-sage-100 text-sage-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Independent Groomers
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-sage-900">
              Meet Our Team
            </h1>
            <p className="text-xl leading-relaxed text-sage-700">
              Alongside our owners, we have a fantastic team of independent groomers. 
              Each groomer runs their own business and takes bookings independently.
            </p>
          </div>
        </div>
      </section>

      {/* Graduates Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {graduates.map((graduate) => (
              <Card key={graduate.id} className="border-sage-200 hover:shadow-xl transition-all bg-white overflow-hidden group">
                {/* Photo */}
                <div className="relative overflow-hidden">
                  <img
                    src={graduate.image}
                    alt={graduate.name}
                    className="w-full aspect-[4/5] object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent p-6">
                    <h3 className="text-2xl font-bold text-white">{graduate.name}</h3>
                  </div>
                </div>
                
                {/* Logo */}
                <div className="bg-white p-4 flex justify-center">
                  <img
                    src={graduate.logo}
                    alt={`${graduate.businessName} logo`}
                    className="w-24 h-24 object-contain"
                  />
                </div>
                
                {/* Contact Info */}
                <CardContent className="p-4 pt-0">
                  <div className="flex items-center justify-center gap-4">
                    {graduate.instagram && (
                      <a
                        href={`https://www.instagram.com/${graduate.instagram}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-sage-600 hover:text-sage-800 transition-colors"
                      >
                        <Instagram size={20} />
                        <span className="text-sm font-medium">@{graduate.instagram}</span>
                      </a>
                    )}
                    {graduate.phone && (
                      <a
                        href={`tel:${graduate.phone}`}
                        className="flex items-center gap-2 text-sage-600 hover:text-sage-800 transition-colors"
                      >
                        <Phone size={20} />
                        <span className="text-sm font-medium">{graduate.phone}</span>
                      </a>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-sage-50 to-sage-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-sage-900 mb-4">
              Ready to Book?
            </h2>
            <p className="text-lg text-sage-700 mb-8">
              Contact any of our team members directly via their social media or phone number 
              to book your dog's next pamper session!
            </p>
            <a
              href="/contact"
              className="inline-flex items-center bg-gradient-to-r from-sage-600 to-sage-700 hover:from-sage-700 hover:to-sage-800 hover:shadow-xl transition-all font-medium gap-2 px-8 py-3 rounded-lg shadow-lg text-white"
            >
              Contact Pups & Dreams
            </a>
          </div>
        </div>
      </section>
    </div> 
  );
};

export default GraduatesPage;
